import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

type PendingCuttingRoomProject = {
  title: string;
  /** Set once the create has asked the iframe to open the new project. */
  projectId?: string;
};

type CuttingRoomAppState = {
  projectId: string | null;
  projectTitle: string | null;
  /** Set from the start of a create until the new project has loaded. */
  pendingProject: PendingCuttingRoomProject | null;
};

const initialState: CuttingRoomAppState = {
  projectId: null,
  projectTitle: null,
  pendingProject: null,
};

export const cuttingRoomSlice = createSlice({
  name: 'cutting_room',
  initialState,
  reducers: {
    setCuttingRoomProjectId: (state, action: PayloadAction<string>) => {
      state.projectId = action.payload;
      state.projectTitle = null;
    },
    setCuttingRoomProjectTitle: (state, action: PayloadAction<string>) => {
      state.projectTitle = action.payload;
    },
    setCuttingRoomPendingProject: (
      state,
      action: PayloadAction<PendingCuttingRoomProject>,
    ) => {
      state.pendingProject = action.payload;
    },
    clearCuttingRoomPendingProject: (state) => {
      state.pendingProject = null;
    },
    cuttingRoomProjectLoaded: (state) => {
      // A load before the create has opened its project is whichever project
      // the iframe was already showing.
      if (state.pendingProject?.projectId) {
        state.pendingProject = null;
      }
    },
  },
});

export const {
  setCuttingRoomProjectId,
  setCuttingRoomProjectTitle,
  setCuttingRoomPendingProject,
  clearCuttingRoomPendingProject,
  cuttingRoomProjectLoaded,
} = cuttingRoomSlice.actions;

export const cuttingRoomReducer = cuttingRoomSlice.reducer;
